import React from "react";
import styled from "styled-components";
import { UI_TAG } from "oolib/dist/v2/components/Typo2";
import { CONFIG } from "../SignalsWidget/CONFIG";

/**
 * Signal category pill. Shared between the LensesV2 Signals widget and the
 * TopicClusteringTreeView (mid-level cluster rows). Colour comes from
 * SignalsWidget/CONFIG.categoryStyle (single source of truth); pass the
 * signal's `category` value and a display `label`.
 *
 * Optional `size` prop tunes padding/typography — "S" for compact usage
 * (topic cluster rows), default matches SignalsWidget dimensions.
 *
 * Optional `muted` drops the pill's presence without changing its colour
 * identity — for places where the signal is context rather than the point
 * (e.g. loose observations sitting under a finding).
 *
 * Optional `colors` ({ bg, color }) overrides the category lookup — for
 * pills that aren't signals but should look exactly like one (the
 * Priorities view's zone pills).
 */

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: ${(p) => (p.$size === "S" ? "0.15rem 0.5rem" : "0.2rem 0.625rem")};
  border-radius: 999px;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$color};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
  opacity: ${(p) => (p.$muted ? 0.55 : 1)};
`;

export const SignalBadge = ({ category, label, size, muted, colors }) => {
  const style = CONFIG.categoryStyle[category] || CONFIG.defaultCategoryStyle;
  return (
    <Badge $bg={colors?.bg || style.badgeBg} $color={colors?.color || style.badgeColor} $size={size} $muted={muted}>
      <UI_TAG style={{ color: "inherit" }}>{label}</UI_TAG>
    </Badge>
  );
};
